import React from "react";
import { TextField, MenuItem } from "@mui/material";

const SelectOrg = ({ user, access, setAccess }) => {

  const handleChange = e => setAccess(user.access.find(i=>i.org.id===e.target.value))

  return (
    <TextField
      id="org"
      value={access.org.id || ''}
      label="Organization"
      onChange={handleChange}
      size="small"
      variant="standard"
      sx={{'@media (min-width:600px)': { mr: 2, minWidth: 300 }}}
      select
    >
      {user.access.filter(e => e.clinic || e.consult).map(e => (
        <MenuItem key={e.org.id} value={e.org.id}>
          {e.org.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SelectOrg;
